import React from "react";
import { RubriqueBlock } from "./Rubrique";
import { useParams2 } from "../contexts/ParamsContext";

export default function Commune() {
  const params = useParams2();
  const lat = params.carte_lat || "48.1097";
  const lon = params.carte_lon || "0.0856";
  const bbox = `${parseFloat(lon) - 0.012},${parseFloat(lat) - 0.008},${parseFloat(lon) + 0.012},${parseFloat(lat) + 0.008}`;

  return (
    <div className="container">
      <h1>La commune</h1>
      <p className="muted mb-3">
        {params.commune_population
          ? `${params.commune_population} habitants · Sarthe (72240)`
          : "Sarthe (72240)"}
      </p>
      <RubriqueBlock cle="presentation" />
      <div className="map-wrap mt-3">
        <iframe
          title="Carte de la commune"
          src={`https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lon}`}
        />
      </div>
    </div>
  );
}
